import ApiKeys from "./apiKeys";
let apiBaseUrl = window._siteProps_?.props?.apibaseurl;
let apiBaseUrl2 = window._siteProps_?.props?.apibaseurl2;
let apiBaseUrl3 = window._siteProps_?.props?.apibaseurl3;
let apiBaseUrlInternal = window._siteProps_?.props?.apiBaseUrlInternal;
let imgBaseUrl = window._siteProps_?.props?.imgbaseurl;
let staticImgBaseUrl = window._siteProps_?.props?.staticimgbaseurl;
let projectBasePathWithFolder =
  window._siteProps_?.props?.projectbasepathwithfolder;
let PROXY_PATH = "";
let clientPlatform = window._siteProps_?.platform;
let menuItemsToShowUpfront = window._siteProps_?.props?.menuItemsToShowUpfront;
let paymentsProjectBasePath =
  window._siteProps_?.props?.paymentsprojectbasepathwithfolder;
let siteContext = window._siteProps_?.siteContext;
let cms_lang_id = window._siteProps_?.props?.lang_id;
let cms_platform_id = window._siteProps_?.props?.platform_id;
let redirectToMapScreenAfterSeconds =
  +window._siteProps_?.props?.redirectToMapScreenAfterSeconds || 0;
const ab_test_variant = window._siteProps_?.props?.ab_test_variant;
const site = window._siteProps_?.props?.site;
const shouldHideCompleteLocationFlow =
  window?._siteProps_?.props?.shouldHideCompleteLocationFlow === "true";
const shouldLoginFlowSkip =
  window?._siteProps_?.props?.shouldLoginFlowSkip === "true";
const mediaBaseUrlDefault =
  "https://api-s1.popeyes.in/nextgen-catalog/media/stage/s1/";
const showNudgeModal = window?._siteProps_?.props?.showNudgeModal === "true";
const showItemToast = window?._siteProps_?.props?.showItemToast === "true";

let v2PwaBasePath = PROXY_PATH + "https://hongs-dev0.hongskitchen.in";
// PROXY_PATH = "http://localhost:3002/";
// projectBasePathWithFolder = location.origin + "/jfl-discovery-ui/en/pwa";
// (apiBaseUrl = "https://hongs-dev0-backend-int-alb.hongskitchen.in"),
//   (apiBaseUrl2 = "https://dev0.hongskitchen.in");
// apiBaseUrl3 = "https://dev0.hongskitchen.in";
// projectBasePathWithFolder = location.origin + "/jfl-discovery-ui/en/pwa";
// staticImgBaseUrl = location.origin + "/jfl-discovery-ui/public/dist/default";
// apiBaseUrlInternal =
//   "http://internal-hongs-dev0-int-alb-612363884.ap-south-1.elb.amazonaws.com";

let countryCodeFromDomain;
switch (window._siteProps_?.props?.build_env_var) {
  case "production":
    if (location.host.includes("hongskitchen.in")) {
      countryCodeFromDomain = "IN";
    } else if (location.host.includes("hongskitchen.com.bd")) {
      countryCodeFromDomain = "BG";
    } else {
      countryCodeFromDomain = "SL";
    }
    break;
  case "qa":
  case "dev":
  case "local":
  default:
    countryCodeFromDomain = "IN";
}

let countryFromDomain;
switch (window._siteProps_?.props?.build_env_var) {
  case "production":
    if (location.host.includes("hongskitchen.in")) {
      countryFromDomain = "INDIA";
    } else if (location.host.includes("hongskitchen.com.bd")) {
      countryFromDomain = "BANGLADESH";
    } else {
      countryFromDomain = "SRILANKA";
    }
    break;
  case "qa":
  case "dev":
  case "local":
  default:
    countryFromDomain = "INDIA";
}

let domainReferrerFromDomain;
switch (window._siteProps_?.props?.build_env_var) {
  case "production":
    domainReferrerFromDomain = "https://" + location.host + "/";
    break;
  case "qa":
  case "dev":
  case "local":
  default:
    domainReferrerFromDomain = "https://hongskitchen.in/";
}

const urls = {
  HONGS_API_BASE_URL: PROXY_PATH + apiBaseUrl,
  NXGN_HONGS_INTERNAL_API_BASE_URL:
    PROXY_PATH + "https://hongs-dev0-backend-int-alb.hongskitchen.in",
  HONGS_API_BASE_URL2: PROXY_PATH + apiBaseUrl2,
  DOMINOS_API_BASE_URL3: PROXY_PATH + apiBaseUrl3,
  HONGS_INTERNAL_API_BASE_PATH: PROXY_PATH + apiBaseUrlInternal,
  GOOGLE_API_BASE_URL:
    PROXY_PATH + window._siteProps_?.props?.google_api_base_url,
  ONDEMAND_API_BASE_URL:
    PROXY_PATH + window?._siteProps_?.props?.onDemandApiBaseUrl,
};

let END_POINT = JSON.parse(window._siteProps_.props.envConfig);
let env = window._siteProps_?.props?.build_env_var || "production";

let GOOGLE_MAPS_API_KEY =
  ApiKeys.GOOGLE_MAPS_API_KEY_MAP[countryCodeFromDomain][site][env];

const EndPoints = {
  envConfig: END_POINT,
  currentEnv: env,
  domain:
    PROXY_PATH + "https://hongs-dev0.hongskitchen.in" ||
    `${END_POINT.hostname}`,
  hostedDomain: `${END_POINT.domain}`,
  apiURL:
    PROXY_PATH + "https://hongs-dev0.hongskitchen.in" ||
    `${END_POINT.hostname}`,
  AMPLITUDE_API_KEY: END_POINT.AMPLITUDE_API_KEY,
  AMPLITUDE_API_KEY_GPAY: END_POINT.AMPLITUDE_API_KEY_GPAY,
  AMPLITUDE_API_KEY_PAYTM: END_POINT.AMPLITUDE_API_KEY_PAYTM,
  AMPLITUDE_INSTANCE_NAME: END_POINT.AMPLITUDE_INSTANCE_NAME,
};
// @todo : replace 'DOMINOS_API_BASE_URL3' with 'HONGS_API_BASE_URL3' and 'HONGS_INTERNAL_API_BASE_PATH' with 'HONGS_INTERNAL_API_BASE_PATH' when hongs apis are deployed on hongs servers
const apiEndpoints = {
  // REFRESH_TOKEN: urls.HONGS_API_BASE_URL + "/sso-service/ve1/user/refresh",
  // REFRESH_TOKEN_ANONYMOUS:
  //   urls.HONGS_API_BASE_URL + "/sso-service/ve1/user/guest/refresh",
  REFRESH_TOKEN: urls.HONGS_API_BASE_URL + "/loginhandler/refreshtoken",
  REFRESH_TOKEN_ANONYMOUS:
    urls.HONGS_API_BASE_URL + "/loginhandler/refreshtokenanonymous",
  STORE_OFFERS: urls.HONGS_API_BASE_URL + "/nxg-middleware/ext/cart/v1",
  LEFT_MENU: urls.HONGS_API_BASE_URL + "/catalog-service/ve1/stores",
  OFFER_TNC: urls.HONGS_API_BASE_URL + "/nxg-middleware/ext/promo/v1/",
  SYNC_CART_ITEMS: urls.HONGS_API_BASE_URL + "/nxg-middleware/ext/cart/v1",
  USER_LOYALTY: urls.HONGS_API_BASE_URL + "/customer-service/ve1/loyalty/user",
  MENU_SEQUENCING:
    urls.HONGS_API_BASE_URL +
    "/jfl-personalization/ve1/api/public/sites/v1/menu-data-sequence",
  WALLET_BALANCE:
    urls.HONGS_API_BASE_URL + "/wallet-service/ve3/wallet/balance",
  PIZZA_TOPPING: urls.HONGS_API_BASE_URL + "/prod-olo-api/v1",
  PREVIOUS_ORDER: urls.HONGS_API_BASE_URL + "/order-service/ve3",
  ESTIMENT_ORDER_TIME:
    urls.HONGS_API_BASE_URL + "/order-service/ve1/orders/tracker/trackOnMap",
  SEND_TRACKER_STATUS:
    urls.HONGS_API_BASE_URL + "/tracker-service/ve2/sendtrackerstatus",
  // PAYMENT_OFFER_TNC:
  //   urls.DOMINOS_API_BASE_URL3 +
  //   "/jfl-discovery-service/ve1/api/public/sites/v1/tnc",
  USER_ACTIVITY_TRACKING:
    urls.HONGS_API_BASE_URL + "/user-activity-tracking/ve/v1/savePageViewData",
  PWA_CONFIG_API: urls.HONGS_API_BASE_URL + "/api/ve1/pwa-config",
  APP_CONFIG_API: urls.HONGS_API_BASE_URL + "/api/ve1/app-config",
  ALL_FAVOURITES: `${urls.HONGS_API_BASE_URL}/jfl-personalization/ve2/api/public/sites/v1/allFavourite?tenantKey=jflcms-hongs&site=${site}`,
  // start login endpoints
  // ANONYMOUS_USER: urls.HONGS_API_BASE_URL + "/sso-service/ve1/user/guest/",
  ANONYMOUS_USER: urls.HONGS_API_BASE_URL + "/loginhandler/anonymoususer",
  LOGOUT_USER: `${urls.HONGS_API_BASE_URL}/sso-service/ve1/user/logout?site=${site}`,
  FORGOT_PASSWORD: ` ${urls.HONGS_API_BASE_URL}/sso-aggregation/ve2/forgotpassword?site=${site}`,
  VALIDATE_CODE: `${urls.HONGS_API_BASE_URL}/loginhandler/validatecode?site=${site}`,
  // end login endpoints
  // start locator endpoints
  GEOCODE: urls.HONGS_API_BASE_URL + "/locator-service/ve2/geocode",
  LOCATOR_STORES: `${urls.HONGS_API_BASE_URL}/locator-service/ve2/stores?site=${site}`,
  NEAREST_STORE: `${urls.HONGS_API_BASE_URL}/locator-service/ve3/nearest-store?site=${site}`,
  LOCATOR_STORES_TAKEAWAY:
    urls.HONGS_API_BASE_URL + "/locator-service/ve3/stores",
  AUTO_COMPLETE: urls.HONGS_API_BASE_URL + "/locator-service/ve2/autocomplete",
  // end locator endpoints
  // start user specific endpoints
  SAVED_ADDRESSES: urls.HONGS_API_BASE_URL + "/customer-service/ve2/user/",
  UPDATE_ADDRESS:
    urls.HONGS_API_BASE_URL + "/customer-service/ve2/user/addresses/",
  ADD_ADDRESS: urls.HONGS_API_BASE_URL + "/customer-service/ve2/user/",
  DELETE_ADDRESS:
    urls.HONGS_API_BASE_URL + "/customer-service/ve2/user/addresses/",
  // end user specific endpoints
  FAVOURITE_IDS: `${urls.HONGS_API_BASE_URL}/jfl-personalization/ve2/api/public/sites/v1/favourite?site=${site}`,
  ADD_TO_FAVOURITE: `${urls.HONGS_API_BASE_URL}/jfl-personalization/ve2/api/public/sites/v1/add/favourite?site=${site}`,
  REMOVE_FROM_FAVOURITE: `${urls.HONGS_API_BASE_URL}/jfl-personalization/ve2/api/public/sites/v1/remove/favourite?site=${site}`,
  INLINE_NOTIFICATION:
    urls.HONGS_API_BASE_URL +
    "/jfl-inline-notification/ve1/api/public/sites/v1/notification",
  BANNER_OFFERS: `${urls.HONGS_API_BASE_URL}/jfl-discovery-service/ve1/api/public/sites/v1/banner-offer?platform=pwa&lang=en&site=${site}`,
  HAMBURGER_ITEMS:
    urls.HONGS_API_BASE_URL +
    "/jfl-discovery-service/ve1/api/public/sites/v1/leftNav-data",
  GET_USER_INFO: urls.HONGS_API_BASE_URL + "/sso-service/ve1/user/",
  UPDATE_USER_INFO: urls.HONGS_API_BASE_URL + "/loginhandler/updateuser",
  // track order apis
  TRACK_ORDERS: urls.HONGS_API_BASE_URL + "/tracker-service/ve2/orders",
  TRACK_ON_MAP: urls.ONDEMAND_API_BASE_URL,
  // cart apis
  GENERATE_CART_ID:
    urls.HONGS_API_BASE_URL + "/agg/cart-service/ve1/cart/get-cart-id",
  GLOBAL_UPSELLS_ITEMS:
    urls.HONGS_API_BASE_URL + "/nxg-middleware/ext/cart/v1/cart-cross-sell",
  TRACK_ORDER:
    urls.HONGS_API_BASE_URL + "/order-service/ve3/orders/transaction",
  FINGERPRINT_INFO:
    urls.HONGS_API_BASE_URL + "/sso-aggregation/ve2/finger-print",
  //payment apis
  REFRESH_TOKEN: urls.HONGS_API_BASE_URL + "/loginhandler/refreshtoken",
  REFRESH_TOKEN_ANONYMOUS:
    urls.HONGS_API_BASE_URL + "/loginhandler/refreshtokenanonymous",
  PWA_CONFIG_API: urls.HONGS_API_BASE_URL + "/api/ve1/pwa-config",
  APP_CONFIG_API: urls.HONGS_API_BASE_URL + "/api/ve1/app-config",
  RECOMMENDED_PAYMENT_OPTION:
    urls.HONGS_API_BASE_URL +
    "/payment-service/ve5/recommendedOptions?order_for_someOneElse=false",
  OTHER_PAYMENT_OPTION:
    urls.HONGS_API_BASE_URL +
    "/payment-service/ve5/options?client_type=mobile-android-1.0",
  GET_PAYTM_WALLET_BALANCE:
    urls.HONGS_API_BASE_URL +
    "/jfl-payment-aggregator/ve1/user/wallet/instrumentbalance",
  // GET_SAVED_CARDS: urls.HONGS_API_BASE_URL + "/saved-card-service/ve2/cards",
  GET_SAVED_CARDS: urls.HONGS_API_BASE_URL + "/saved-card-service/ve4/cards",
  GET_PAYTMFORM_OTP:
    urls.HONGS_API_BASE_URL + "/order-service/ve4/user/wallet/paytm/link",
  PAYTMOTP_VERIFY:
    urls.HONGS_API_BASE_URL + "/order-service/ve4/user/wallet/paytm/verify",
  PAYTM_SUBMIT_ORDER:
    urls.HONGS_API_BASE_URL +
    "/payment-verify-service/ve4/orders/paytm_wallet/redeem",
  SUBMIT_ORDER:
    urls.HONGS_API_BASE_URL + "/order-service/ve4/orders/transaction",
  POST_SUBMIT_ORDER:
    urls.HONGS_API_BASE_URL + "/order-service/ve4/orders/submit",
  GET_CHARGE_DATA:
    urls.HONGS_API_BASE_URL +
    "/payment-verify-service/ve4/orders/CHARGE_STATUS/paytm_pg",
  PROCESS_TRANSACTION: "securegw.paytm.in/theia/api/v1",
  PROCESS_PAYMENT:
    urls.HONGS_API_BASE_URL + "/payment-verify-service/ve4/orders/paytm_pg",
  GET_COD_OTP: urls.HONGS_API_BASE_URL + "/payment-service/ve1/orders",
  GET_VOUCHER_OTP: urls.HONGS_API_BASE_URL + "/order-service/ve3/evoucher/",
  REMOVE_PROMO:
    urls.HONGS_API_BASE_URL +
    "/order-service/ve3/orders/transaction/$transactionId/promo/$promo",
  ADVANCE_TIME_ORDER: urls.HONGS_API_BASE_URL + "/locator-service/ve2/stores",
  CART_REMOVE_PROMO: urls.HONGS_API_BASE_URL + "/agg/cart-service/ve1/cart",
  BIN_DISCOUNT_CARD_CHECKER: urls.HONGS_API_BASE_URL + "/cart-service/ve2/cart",
  PAYMENT_STATUS:
    urls.HONGS_API_BASE_URL +
    "/jfl-payment-aggregator/ve1/payment/transaction-status",
  PUT_CART_ITEMS: urls.HONGS_API_BASE_URL + "/agg/cart-service/ve1/cart",
  GET_INITIAL_CART: urls.HONGS_API_BASE_URL + "/nxg-middleware/ext/cart/v1/get",
  GET_SENTINELIZED_API:
    urls.HONGS_API_BASE_URL +
    "/data-security-sentinel/ve1/inbound/redact/unified-payments-cards-input-route",
  //end payment apis

  REORDER_ITEMS:
    urls.HONGS_API_BASE_URL + "/nxg-middleware/ext/cart/v1/reorder",

  // cart payment API
  LAST_SUCCESSFULL_PAYMENT_NEXTGEN: `${urls.HONGS_API_BASE_URL}/payment-service/ve5/payment/options/lastSuccessful?site=${site}`,
  // end cart payment API

  //homepage reorder items
  PREVIOUS_SINGLE_ORDER:
    urls.HONGS_API_BASE_URL +
    "/jfl-discovery-service/ue/api/public/sites/v2/store",
};

const googleApiEndpoints = {
  GOOGLE_GEO_LOCATION: urls.GOOGLE_API_BASE_URL + "/geolocation/v1/geolocate",
  MAP_URL: `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&callback=Function.prototype&libraries=places,maps,geometry&channel=p_dom_in`,
};

export {
  apiEndpoints,
  EndPoints,
  imgBaseUrl,
  staticImgBaseUrl,
  v2PwaBasePath,
  projectBasePathWithFolder,
  countryCodeFromDomain,
  domainReferrerFromDomain,
  countryFromDomain,
  googleApiEndpoints,
  clientPlatform,
  siteContext,
  cms_lang_id,
  cms_platform_id,
  menuItemsToShowUpfront,
  paymentsProjectBasePath,
  shouldHideCompleteLocationFlow,
  shouldLoginFlowSkip,
  showNudgeModal,
  redirectToMapScreenAfterSeconds,
  mediaBaseUrlDefault,
  site,
  showItemToast,
  ab_test_variant,
  env,
};
